import { useCallback, useEffect, useState } from 'react'
import {
  CookieBannerEvent,
  CookieBannerState
} from '@/shared/Types/CookieBannerEvent'

export const useCookieBannerStatus = () => {
  const [state, setState] = useState<CookieBannerState>('invisible')
  const [height, setHeight] = useState(0)

  const cookieBannerChangeListener = useCallback((evt: CookieBannerEvent) => {
    const rect = evt.detail.el.getBoundingClientRect()
    setState(evt.detail.state)
    setHeight(rect.height)
  }, [])

  useEffect(() => {
    window.addEventListener('cookieBannerChange', cookieBannerChangeListener)

    return () =>
      window.removeEventListener(
        'cookieBannerChange',
        cookieBannerChangeListener
      )
  }, [cookieBannerChangeListener])

  return { state, height }
}
